package com.tovtalk.domain.repository

import com.tovtalk.domain.entity.AppConfig
import com.tovtalk.domain.entity.ContactPhoneItem
import com.tovtalk.domain.entity.Category
import com.tovtalk.domain.entity.KosherLevel
import com.tovtalk.domain.entity.DomainResult

/**
 * App Repository Interface - for app-wide data like kosher levels and version config
 */
interface AppRepository {
    suspend fun getKosherLevels(hadranOnly: Boolean = false): DomainResult<List<KosherLevel>>
    suspend fun getCategories(): DomainResult<List<Category>>
    suspend fun getAppConfig(): DomainResult<AppConfig>
    suspend fun getContactPhones(): DomainResult<List<ContactPhoneItem>>

    /** Fetch info page HTML content (about, privacy, terms, account-deletion, safety). API returns JSON with "content" and "locale". */
    suspend fun getPageContent(slug: String, lang: String = "he"): DomainResult<String>

    /** Fetch all admin-managed page slugs. Used at Splash to validate dynamic StaticPage deep links. */
    suspend fun getKnownStaticPageSlugs(): DomainResult<Set<String>>
}
